module.exports = __webpack_public_path__ + "img/img2.e35999cb.png";